import { HttpResponse as Option } from '@/common/entity.types'
import idbKeys from '@/common/idb-key'
import idb from '@/utils/idb'
import { HttpStatusCode } from '@/common/constant'
import TeacherRankingConfigAPI from '@/apis/business/teacher/teacher-ranking-config-api'
import CacheTime from './cache-time'

class TeacherRankingConfig {
  /**
   * @description Lấy thông tin config rank của giáo viên
   * @returns
   * @author VHSON
   */
  public async GetTeacherRankingConfig (): Promise<any> {
    const key = idbKeys.TeacherRankingConfig
    const isExpired = await CacheTime.IsExpiredTime(key)
    let options = null
    // filter width optionID
    // Call API lên server lấy dữ liệu khi:
    // + Hết hạn cache
    // + Không có TeacherRankingConfig trong IndexDB
    // + Có TeacherRankingConfig trong IndexDb nhưng key cần lấy ra không có
    if (isExpired) {
      // doesn't exist on indexeddb
      // @ts-ignore
      const response: HttpResponse = await TeacherRankingConfigAPI.getTeacherRankingConfig()
      if (response.IsSuccess && response.Code === HttpStatusCode.OK) {
        options = response.Data
        await idb.set(key, options)
        await CacheTime.SetCacheTime(key)
      }
    } else {
      options = await idb.get(key, {})
    }
    return options
  }

  /**
   * @description Lấy config theo rank hiện tại của giáo viên
   * @author NTQuy
   * @param ranking
   * @returns
   */
  public async GetCurrentTeacherRankingConfig (ranking: Number): Promise<any> {
    const teacherRankingConfigs = await this.GetTeacherRankingConfig()
    let currentRankingConfig = null

    if (teacherRankingConfigs?.length) {
      currentRankingConfig = teacherRankingConfigs?.find((element: any) => element.Ranking === ranking)
    }

    return currentRankingConfig
  }
}
export default new TeacherRankingConfig()
